const ARTICLE_FIELDS = `
  items {
    ItemId
    Title
    Content
    coverImageUrl
    CreatedDate
    CreatedBy
    LastUpdatedDate
    LastUpdatedBy
    IsDeleted
    Language
    OrganizationIds
    Tags
    DeletedDate
    isDraft
    categoryIds
    authorSnapshot {
      firstName
      lastName
      email
      profileImageUrl
    }
    attachmentUrls {
      id
      name
      size
      url
      mimeType
    }
  }
`;

export const GET_ALL_ARTICLES = `
  query GetAllArticles($filter: String!) {
    getwikis(
      input: {
        filter: $filter
        sort: "{}"
        pageNo: 1
        pageSize: 1000
      }
    ) {
      totalCount
      ${ARTICLE_FIELDS}
    }
  }
`;

export const GET_ARTICLES = `
  query GetArticles($filter: String!, $pageSize: Int!) {
    getwikis(
      input: {
        filter: $filter
        sort: "{}"
        pageNo: 1
        pageSize: $pageSize
      }
    ) {
      ${ARTICLE_FIELDS}
    }
  }
`;

export const GET_ARTICLE = `
  query GetArticle($filter: String!) {
    getwikis(
      input: {
        filter: $filter
        sort: "{}"
        pageNo: 1
        pageSize: 1
      }
    ) {
      ${ARTICLE_FIELDS}
    }
  }
`;

export const DELETE_ARTICLE = `
  mutation DeleteArticle($filter: String!) {
    deletewiki(filter: $filter, input: { isHardDelete: true }) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

export const CREATE_ARTICLE = `
  mutation CreateArticle($input: wikiInsertInput!) {
    insertwiki(input: $input) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

export const UPDATE_ARTICLE = `
  mutation UpdateArticle($filter: String!, $input: wikiUpdateInput!) {
    updatewiki(filter: $filter, input: $input) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;
